import { Axios } from '../../axios';

const getNHF = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : '';

  const { data } = await Axios.get(
    `/statutory-payments/nhf?limit=${payload.limit}&page=${payload.page}${search}`,
  );

  return data?.data;
};

const bulkNHF = async (payload) => {
  const { data } = await Axios.post('/statutory-payments/nhf/bulk', payload);
  return data;
};

const fetchNHFByRef = async (payload) => {
  const { data } = await Axios.get('/statutory-payments/nhf/by-ref/' + payload);
  return data;
};

export const nhfApis = {
    getNHF,
    bulkNHF,
    fetchNHFByRef,
};